// extracted by mini-css-extract-plugin
export default {"container":"RechartsWrapper_container__DNdBi"};